<div class="row mb-4">
  <div class="col-md-auto">
    <h5 *ngIf="showTitle" class="card-title mb-4">
      {{ getKey("title") | msg | async }}
    </h5>
  </div>
  <div class="col"></div>
  <div *ngIf="enablePagination && showItemsPerPage" class="col-md-auto my-auto">
    {{ "table.pagination.itemsPerPage" | msg | async }}:
    <select
      class="form-select-sm shadow-none"
      (change)="handlePageSizeChange($event)"
    >
      <option *ngFor="let size of pageSizes" [ngValue]="size">
        {{ size }}
      </option>
    </select>
  </div>
  <div *ngIf="isLoading" class="d-flex justify-content-center">
    <div class="spinner-border custom-spinner" role="status"></div>
  </div>
  <div class="table-responsive" *ngIf="showTable && !isLoading">
    <div class="d-none d-lg-block d-xl-block d-md-block">
      <table class="table">
        <thead>
          <tr>
            <th *ngIf="enableCheckbox">
              <input class="form-check-input" type="checkbox" disabled />
            </th>
            <th scope="col" *ngFor="let header of headers">
              {{ getKey(header.name) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let item of items!
                | paginate
                  : {
                      itemsPerPage: pageSize,
                      currentPage: page,
                      totalItems: totalItems
                    }
            "
            (click)="rowSelectable ? selectRow(item) : ''"
          >
            <td *ngIf="enableCheckbox">
              <input class="form-check-input" type="checkbox" />
            </td>
            <td *ngFor="let header of headers">
              <app-table-row [item]="item" [header]="header"></app-table-row>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-block d-lg-none d-xl-none d-md-none">
      <div class="list-group list-group-flush">
        <div
          class="list-group-item"
          *ngFor="
            let item of items!
              | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
          (click)="rowSelectable ? selectRow(item) : ''"
        >
          <ng-container *ngFor="let header of headers">
            <h6 class="mb-1">{{ getKey(header.name) }}</h6>
            <app-table-row [item]="item" [header]="header"></app-table-row>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="enablePagination" class="text-center">
      <pagination-controls
        previousLabel="{{ 'pagination.previous' | msg | async }}"
        nextLabel="{{ 'pagination.next' | msg | async }}"
        (pageChange)="handlePageChange($event)"
      ></pagination-controls>
    </div>
  </div>
  <div class="text-center" *ngIf="!showTable && !isLoading">
    {{ "pagination.noMatches" | msg | async }}
  </div>
</div>
